import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-srm',
  templateUrl: './srm.component.html',
  styleUrls: ['./srm.component.scss']
})
export class SrmComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
